module.exports = __webpack_public_path__ + "static/media/noun_Settings_2828156.f3991a90.svg";